import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import file from "../../../../assets/svg/File.svg";
import category from "../../../../assets/svg/category.svg";
import role from "../../../../assets/svg/role.svg";
import note from "../../../../assets/svg/note.svg";
import calender from "../../../../assets/svg/calender.svg";
import infoBlack from "../../../../assets/svg/infoBlack.svg";
import "react-datepicker/dist/react-datepicker.css";
import "date-fns";
import dateIcon from "../../../../assets/svg/calendar-inside.svg";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Icon from "@material-ui/core/Icon";
import DateFnsUtils from "@date-io/date-fns";
import $ from "jquery";
import moment from "moment";
import Autocomplete from "react-autocomplete";
import Select from "react-select";
import submit from "../../../../assets/svg/submit.svg";
import {
  rightBarClose,
  searchDataStore,
  searchResultStore,
  searchStateFn,
  searchTrigger,
} from "../../../../redux/action/Action";
import {
  GET_ALL_USERS,
  GET_CATAGORY_DROPDOWN,
  GET_FILE_TYPE,
  GET_REVIEWERS,
  GET_STATUS,
  POST_CATEGORIES,
  POST_NEW_DOCUMENT,
  POST_REGISTER_DOCUMENT,
  POST_RENEW_DOCUMENT,
  POST_SEARCH_DETAILS,
} from "../../../../helpers/endpointService";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import search from "../../../../assets/svg/search.svg";
import { DOCUMENTS, SEARCH } from "../../../../helpers/routerPaths";
import { useNavigate } from "react-router";
import { logoutFunction } from "../../../custom/commonFunction";

var SelectedValue1 = false;
var SelectedValue2 = false;

export default function NewDocument({ rightbarOpen }) {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const trigger = useSelector((state) => state.documentReducer.searchTrigger);
  const userId = localStorage.getItem("UserId");
  const [isPropertyLoader, setPropertyLoader] = useState(true);
  const [isPropertyFailed, setPropertyFailed] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);
  const [isSearchSuccess, setSearchSuccess] = useState(true);

  const [category1Default, setCategory1Default] = useState();
  const [category2Default, setCategory2Default] = useState([]);
  const [authorDefault, setAuthorDefault] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [statusDefault, setStatusDefault] = useState();

  const [docNo, setDocNo] = useState("");
  const [docName, setDocName] = useState("");
  const [category1, setCategory1] = useState("");
  const [category2, setCategory2] = useState("");
  const [category1Id, setCategory1Id] = useState(0);
  const [category2Id, setCategory2Id] = useState(0);
  const [opencategory1List, setOpencategory1List] = useState(false);
  const [opencategory2List, setOpencategory2List] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileTypeSelected, setFileTypeSelected] = useState("");
  const [author, setAuthor] = useState("");
  const [authorId, setAuthorId] = useState(0);
  const [openauthorList, setOpenauthorList] = useState(false);
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [category2Change, setcategory2Change] = useState(false);

  const close = () => {
    dispatch(rightBarClose());
    $("body").removeClass("scrollhide");
  };

  useEffect(() => {
    const abortController = new AbortController();

    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }

    const fetchCategory1Data = async () => {
      let cat1ApiUrl = `${GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
      await axios
        .get(cat1ApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setPropertyFailed(false);
            fetchReviewers();
            fetchFileType();
            setCategory1Default(
              response.data?.map((res) => {
                return {
                  value: res.categoryId,
                  label: res.categoryName,
                };
              })
            );
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          setPropertyFailed(true);
          logoutFunction(err?.response?.status);
        });
    };
    fetchCategory1Data();

    ////////////////// Fetch file type ///////////////////////
    const fetchFileType = async () => {
      let fileTypeApiUrl = GET_FILE_TYPE;
      await axios
        .get(fileTypeApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setFileTypes(response.data);
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };

    ////////////////// Fetch Reviewers ///////////////////////
    const fetchReviewers = async () => {
      let reviewerApiUrl = `${GET_ALL_USERS}?includeAdmin=true`;
      await axios
        .get(reviewerApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            setAuthorDefault(
              response.data?.map((res) => {
                return {
                  value: res.id,
                  label: res.userName,
                };
              })
            );
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };
    return () => {
      abortController.abort();
    };
  }, []);

  const fetchCategory2Data = async (id) => {
    let category2ApiUrl = `${POST_CATEGORIES}?category1Id=${id}`;

    axios({
      method: "POST",
      url: category2ApiUrl,
      data: null,
    })
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          setCategory2Default(
            response.data?.map((res) => {
              return {
                label: res.category2Name,
                value: res.category2Id,
              };
            })
          );
        }
      })
      .catch((err) => {
        logoutFunction(err?.response?.status);
      });
  };

  useEffect(() => {
    setCategory2Default([]);
    setCategory2("");
  }, [category1]);

  useEffect(() => {
    setCategory2Default([]);
  }, [category1]);

  ///////////////////////////////////////////// Submit Search ///////////////////////////////////////////

  const submitSearch = () => {
    const selectInputs = document.querySelectorAll(
      ".my-select-class[required]"
    );
    const selectedInputs = Array.from(selectInputs).filter(
      (select) => select.selectedIndex !== 0
    );
    const isSelectValid = selectedInputs?.length > 0;

    const inputs = document.querySelectorAll(".my-input-class[required]");
    const filledInputs = Array.from(inputs).filter(
      (input) => input.value !== ""
    );
    const isInputValid = filledInputs?.length > 0;

    const inputs1 = document.querySelectorAll(".resubmit-autocomplete");
    const filledInputs1 = Array.from(inputs1).filter(
      (input) => input.value !== ""
    );
    const isInputValid1 = filledInputs1?.length > 0;

    const category1Empty = !category1 || category1 === null;
    const category2Empty = !category2 || category2 === null;
    const authorEmpty = !author || author === null;

    const isValid =
      isInputValid ||
      isSelectValid ||
      isInputValid1 ||
      fromDate !== "" ||
      toDate !== "" ||
      !category1Empty ||
      !category2Empty ||
      !authorEmpty;

    if (isValid) {
      setIsFormValid(true);
      setPropertyLoader(true);

      const searchDetails = {
        pageNumber: 1,
        pageSize: 20,
        documentId: 0,
        documentName: docName || null,
        documentNo: docNo || null,
        category1Name: category1?.label || null,
        category2Name: category2?.label || null,
        category1Id: parseInt(category1?.value) || 0,
        category2Id: parseInt(category2?.value) || 0,
        documentStatus: status || null,
        fileId: 0,
        fileName: fileName || null,
        fileType: fileTypeSelected || null,
        authorId: parseInt(author?.value) || 0,
        authorName: author?.label || null,
        fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
        toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
        publishedDate: null,
      };

      if (searchDetails) {
        setSearchSuccess(true);
        dispatch(searchDataStore(searchDetails));
        dispatch(rightBarClose());
        dispatch(searchStateFn(false));
        dispatch(searchTrigger(!trigger));
        $("body").removeClass("scrollhide");
        nav(`/${SEARCH}`);
      }
    } else {
      setIsFormValid(false);
    }
  };

  const handleFromDateChange = (event) => {
    const inputDate = event;
    /* const formattedDate = inputDate ? new Date(inputDate).toISOString().split('T')[0] : ''; */
    setFromDate(inputDate);
  };

  const handleToDateChange = (event) => {
    const inputDate = event;
    setToDate(inputDate);
  };

  const clearSearch = () => {
    dispatch(searchStateFn(false));
    dispatch(rightBarClose());
    dispatch(searchResultStore());
    nav(`/${DOCUMENTS}`);
  };

  const handleSelectCategoryChange = (value, field) => {
    SelectedValue2 = true;
    if (field === "category1Name") {
      setPropertyLoader(true);
      setPropertyFailed(false);
      setCategory1(value);

      if (value) {
        fetchCategory2Data(value?.value);
      }
      setCategory2("");
      setPropertyLoader(false);
      setPropertyFailed(false);
    } else if (field === "category2Name") {
      setcategory2Change(!category2Change);
      setCategory2(value);
    }
  };

  const handleSelectAuthorChange = (value, field) => {
    SelectedValue2 = true;
    if (field === "author") {
      setAuthor(value);
    }
  };

  return (
    <>
      <div
        className={`viewbar ${rightbarOpen ? "viewbarOpen" : ""} ${
          isPropertyLoader ? "overFlowHidden" : ""
        }`}
      >
        {isPropertyLoader && (
          <div className="loader-new-1">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        )}

        <ToastContainer
          limit={1}
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        {isPropertyFailed && (
          <div className="loader-new-1">
            <span>Loading failed</span>
          </div>
        )}

        <div className="viewMain">
          <div className="viewTitle">
            <span>Search</span>
            <span className="close mt-2" onClick={close}>
              ✕
            </span>
          </div>
          {category1Default && (
            <div>
              <div className="row mt-3">
                <div className="col-sm-6 col-12 d-flex flex-column">
                  <div className="inputTitle commonsearch-field">
                    <span>
                      <img
                        style={{ position: "relative", top: "-1px" }}
                        src={infoBlack}
                        alt=""
                      />{" "}
                      Document no.
                    </span>
                  </div>
                  <input
                    style={{ fontSize: "12px" }}
                    value={docNo}
                    onChange={(e) => setDocNo(e.target.value)}
                    maxlength={255}
                    className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  />
                </div>
                <div className="col-sm-6 col-12 d-flex flex-column topfield">
                  <div className="inputTitle commonsearch-field ">
                    <img src={file} alt="" />
                    <span> Document name</span>
                  </div>
                  <input
                    style={{ fontSize: "12px" }}
                    value={docName}
                    onChange={(e) => setDocName(e.target.value)}
                    maxlength={255}
                    className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className={`col-sm-6 col-12`}>
                  <div className="inputTitle mt-1 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Category 1&nbsp;
                      <span style={{ color: "#ee192d" }}></span>
                    </span>
                  </div>
                  <div className="mt-2">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={category1}
                      options={category1Default}
                      defaultValue={category1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) =>
                        handleSelectCategoryChange(e, "category1Name")
                      }
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 topfield`}>
                  <div className="inputTitle mt-1 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Category 2&nbsp;
                      <span style={{ color: "#ee192d" }}></span>
                    </span>
                  </div>
                  <div className="mt-2">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={category2}
                      isDisabled={!category1}
                      options={category2Default}
                      defaultValue={category2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) =>
                        handleSelectCategoryChange(e, "category2Name")
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle commonsearch-field">
                    <img src={file} alt="" />
                    <span> File name</span>
                  </div>
                  <input
                    style={{ fontSize: "12px" }}
                    value={fileName}
                    maxLength={255}
                    onChange={(e) => setFileName(e.target.value)}
                    className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  />
                </div>
                <div className="col-sm-6 col-12 topfield">
                  <div className="inputTitle commonsearch-field">
                    <img src={file} alt="" />
                    <span> File type</span>
                  </div>
                  <select
                    value={fileTypeSelected}
                    onChange={(e) => setFileTypeSelected(e.target.value)}
                    className="form-control my-select-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  >
                    <option value="">Select</option>
                    {fileTypes?.map((option) => (
                      <option
                        key={option.filetypeName}
                        value={option.filetypeName}
                      >
                        {option.filetypeName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row mt-3">
                <div className={`col-sm-6 col-12`}>
                  <div className="inputTitle commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Author&nbsp;<span style={{ color: "#ee192d" }}></span>
                    </span>
                  </div>
                  <div className="SelectContainer2">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={author}
                      options={authorDefault}
                      defaultValue={author || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectAuthorChange(e, "author")}
                    />
                  </div>
                </div>

                <div className="col-sm-6 col-12 topfield">
                  <div className="inputTitle date-bottom commonsearch-field">
                    <img src={calender} alt="" />
                    <span> Date - From</span>
                  </div>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control f-12 date-from-height"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<img src={dateIcon} />}
                      format="dd-MMM-yyyy"
                      value={fromDate ? fromDate : null}
                      size="small"
                      onChange={(e) => handleFromDateChange(e)}
                      maxDate={toDate}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle date-bottom commonsearch-field">
                    <img src={calender} alt="" />
                    <span> Date - To</span>
                  </div>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control border-radius f-12 SelectContainer2 date-dropdown-height"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<img src={dateIcon} />}
                      format="dd-MMM-yyyy"
                      value={toDate ? toDate : null}
                      size="small"
                      onChange={(e) => handleToDateChange(e)}
                      minDate={fromDate}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
              {!isFormValid && (
                <p style={{ color: "red" }}>At least one field is mandatory</p>
              )}

              <div className="button" style={{ display: "flex" }}>
                <button id="edit2" onClick={clearSearch}>
                  <span className="clear-icon-position">✕</span>
                  <span>Clear</span>
                </button>
                <button id="edit" onClick={submitSearch}>
                  <img
                    style={{
                      marginTop: "-4px",
                      marginRight: "4px",
                      width: "14px",
                    }}
                    src={search}
                    alt=""
                  />
                  Search
                </button>
              </div>

              {!isSearchSuccess && (
                <p style={{ color: "red", marginTop: "20px" }}>Search failed</p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
